module.exports = __webpack_public_path__ + "media/public/img/product-bg-32101ccba3a89ccd3141e05e9153d52d.png";